export const ATTENDANCE_WORK_SCHEDULE_PERMISSION_CODES = {
  WEB_ATTENDANCE_WORK_SCHEDULE_LIST: 'WEB_ATTENDANCE_WORK_SCHEDULE_LIST',
  WEB_ATTENDANCE_WORK_SCHEDULE_DETAIL: 'WEB_ATTENDANCE_WORK_SCHEDULE_DETAIL',
  WEB_ATTENDANCE_WORK_SCHEDULE_ADD: 'WEB_ATTENDANCE_WORK_SCHEDULE_ADD',
  WEB_ATTENDANCE_WORK_SCHEDULE_EDIT: 'WEB_ATTENDANCE_WORK_SCHEDULE_EDIT',
  WEB_ATTENDANCE_WORK_SCHEDULE_DELETE: 'WEB_ATTENDANCE_WORK_SCHEDULE_DELETE',
  WEB_ATTENDANCE_WORK_SCHEDULE_IMPORT: 'WEB_ATTENDANCE_WORK_SCHEDULE_IMPORT',
  WEB_ATTENDANCE_WORK_SCHEDULE_EXPORT: 'WEB_ATTENDANCE_WORK_SCHEDULE_EXPORT',
} as const
